import React from 'react';
import {SecSubTitle, SecTitle, ServiceBoxOne, TitleWrap} from '../../components';
import ServiceBoxOneEInvoice from "../../components/ServiceBox/ServiceBoxOneEInvoice";
import {Link} from "react-router-dom";

const ServiceOneEInvoiceKSA = ({data,title,className})=>  (
  <div  className="background-image space-top" style={{backgroundImage: 'url(images/bg/about-bg-5-1.jpg)'}}>
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-lg-8 col-xl-6">
          <TitleWrap>
            <SecTitle className="h2">{title}</SecTitle>
          </TitleWrap>
        </div>
      </div>
      <div className="row justify-content-center ">
        {data.map(item => (
          <div className="col-md-4 col-lg-3" key={item.id}>
            <div style={{padding: '10px 20px', minHeight: 130, textAlign:'center'}} className={`service-style1 ${className || ''}`}>
              <div className="service-bg background-image"
                   style={{backgroundImage: 'url(' + 'images/bg/sr-box-bg-1.jpg' + ')'}}></div>
              <h5 className="service-title h6"><Link to={"#"}>{item?.title}</Link></h5>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ServiceOneEInvoiceKSA;